import React, { useEffect, useState } from 'react';
import { render } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import ProjectBoardNav from './components/ProjectBoardNav';
import './ProjectBoardList.css';
import {
  fetchProjects,
  fetchProjectsByLocation,
  archiveProject,
  favouriteProject,
  unFavouriteProject,
  saveSearch,
} from '../../store/actions/projects/projects.action';
import Mobile from './views/Mobile';
import LargeScreen from './views/LargeScreen';
import Map from '../../components/map/Map';
import InfoWindow from '../../components/map/infoWindow/InfoWindow';
import imageMarker from '../../assets/img/marker.png';
import { authLogin } from '../../store/actions/authentication.action';
import { authUser } from '../../store/selectors/users/user.selector';
import Geolocation from '../../components/geolocation/Geolocation';
import { isEmpty } from '../../utils/helpers/helper';

const sortItems = [
  {
    id: 1,
    key: 'last_modified_date',
    value: 'updated',
  },
  {
    id: 2,
    key: 'created_date',
    value: 'newest',
  },
  {
    id: 3,
    key: 'bid_due_date',
    value: 'Bid due date',
  },
  {
    id: 4,
    key: 'sf_size',
    value: 'Square Feet',
  },
  {
    id: 5,
    key: 'project_completion',
    value: 'Near completion',
  },
  {
    id: 6,
    key: 'plan_drawings',
    value: 'Plans Drawings',
  },
  {
    id: 7,
    key: 'public_works',
    value: 'Public works',
  },
];
const ProjectBoardList = () => {
  const [selectedTab, setSelectedTab] = useState('list');
  const [selectedSortItem, setSelectedSortItem] = useState(sortItems[0].value);
  const [filters, setFilters] = useState([]);
  const [userLocation, setUserLocation] = useState({});
  // const [latLng, setLatLng] = useState({
  //   latitude: userLocation?.lat,
  //   longitude: userLocation?.lng,
  // });
  const [latLng, setLatLng] = useState({
    latitude: 44.3258932,
    longitude: -93.955691,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [queryStringParam, setQueryStringParam] = useState('');
  const [showSaveSearchModal, setShowSaveSearchModal] = useState(false);
  const [zoom, setZoom] = useState(3)
  const dispatch = useDispatch();
  const {
    projects,
    loading,
    count,
    favouriteProjects,
    phases,
    sizes,
    buildingTypes,
  } = useSelector((state) => state.projects);
  const authenticatedUser = useSelector(authUser());

  useEffect(() => {
    if (!authenticatedUser) {
      dispatch(authLogin({}));
    }
    if (!isEmpty(userLocation)) {
      setLatLng({ latitude: userLocation?.lat, longitude: userLocation?.lng });
    }
  }, [authenticatedUser, userLocation]);

  useEffect(() => {
    const timer = setTimeout(() => {
     handleSetQueryString();
     handleSearchLatLng();
    }, 3000);
    
   return () => clearTimeout(timer);
  }, [currentPage]);

  const handleSetSelectedTab = (tab) => {
    setSelectedTab(tab);
  };

  const handleSelectedSortItem = (itemId) => {
    const item = sortItems.find((item) => item.id === itemId);
    setSelectedSortItem(item.value);
    handleSetQueryString(...filters);
  };

  const handlePageChanged = (data) => {
    const { currentPage } = data;
    setCurrentPage(currentPage);
  };

  const handleSetQueryString = (
    phaseFilters,
    sizeFilters,
    projectTypes,
    searchValue
  ) => {
    setFilters([phaseFilters, sizeFilters, projectTypes, searchValue]);
    const item = sortItems.find((item) => item.value === selectedSortItem);
    var obj = {
      phases: phaseFilters,
      sizes: sizeFilters,
      project_types: projectTypes,
      project_name_or_city: searchValue,
      sort: item.key,
      page: currentPage,
    };
    const queryString = Object.keys(obj)
      .map((key) => {
        if (obj[key]) {
          return `${key}=${obj[key]}`;
        }
      })
      .filter((key) => !!key)
      .join('&');
    dispatch(fetchProjects(queryString));
    setQueryStringParam(queryString);
    return queryString;
  };

  const fetchProjectByLocations = (locations) => {
    dispatch(fetchProjectsByLocation(JSON.stringify(locations)));
  };

  const handleArchive = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    dispatch(archiveProject(id));
  };

  const handleFavourite = (e, type, id) => {
    e.stopPropagation();
    e.preventDefault();
    if (type === 'favourite') {
      dispatch(favouriteProject(id));
      return;
    }
    dispatch(unFavouriteProject(id));
  };

  const handleSaveSearch = (searchName) => {
    const data = {
      search_name: searchName,
      search_query: queryStringParam,
    };
    dispatch(saveSearch(data));
    setShowSaveSearchModal(false);
  };

  const createInfoWindow = (e, map, marker) => {
    const infoWindow = new window.google.maps.InfoWindow({
      content: '<div id="infoWindow"></div>',
      position: { lat: e.latLng.lat(), lng: e.latLng.lng() },
    });
    infoWindow.addListener('domready', (e) => {
      render(<InfoWindow />, document.getElementById('infoWindow'));
    });
    infoWindow.open(map, marker);
  };

  const handleSearchLatLng = (latLng = null) => {
    if (latLng) {
      setLatLng({ latitude: latLng.lat, longitude: latLng.lng });
      setZoom(9)
      return;
    }

    if (userLocation?.lat && userLocation?.lng) {
      const latitude = parseFloat(userLocation?.lat);
      const longitude = parseFloat(userLocation?.lng);
      setLatLng({ latitude, longitude });
      setZoom(9);
      return;
    }
    if (projects?.[0]) {
      const latitude = parseFloat(projects?.[0].latitude);
      const longitude = parseFloat(projects?.[0].longitude);
      setLatLng({ latitude, longitude });
    }
  };

  // let latitude = 44.3258932;
  // let longitude = -93.955691;
  // if (projects?.[0]) {
  //   latitude = parseFloat(projects?.[0].latitude);
  //   longitude = parseFloat(projects?.[0].longitude);
  // }

  // if (!isEmpty(latLng)) {
  //   latitude = parseFloat(latLng.lat);
  //   longitude = parseFloat(latLng.lng);
  // }
  const createMap = () => {
    return (
      <Map
        id="myMap"
        options={{
          // center: { lat: 41.0082, lng: 28.9784 },
          // center: { lat: 44.3258932, lng: -93.955691 },
          center: {
            lat: parseFloat(latLng?.latitude),
            lng: parseFloat(latLng?.longitude),
          },
          zoom: zoom,
          // draggable: false,
        }}
        onMapLoad={(map) => {
          if (projects?.[0]) {
            var marker = new window.google.maps.Marker({
              // position: { lat: 41.0082, lng: 28.9784 },
              position: {
                lat: parseFloat(latLng?.latitude),
                lng: parseFloat(latLng?.longitude),
              },
              map: map,
              title: projects?.[0]?.name || 'N/A',
              icon: imageMarker,
            });
            marker.addListener('click', (e) => {
              createInfoWindow(e, map, marker);
            });
          }
        }}
        selectedLatLng={latLng}
        projects={projects}
        handleFetchProject={fetchProjectByLocations}
        mapZoom={zoom}
      />
    );
  };

  return (
    <div className="">
      <Geolocation setUserLocation={setUserLocation} />
      <section>
        <ProjectBoardNav
          selectedTab={selectedTab}
          setSelectedTab={handleSetSelectedTab}
          setQueryParams={handleSetQueryString}
          phases={phases}
          sizes={sizes}
          buildingTypes={buildingTypes}
          setSearchLatLng={handleSearchLatLng}
          saveSearchHandler={handleSaveSearch}
          queryString={queryStringParam}
          modalState={showSaveSearchModal}
        />
      </section>
      <section className="project-list-container">
        <div className="mx-3">
          <div className="d-md-none">
            <Mobile
              selectedTab={selectedTab}
              count={count}
              selectedSortItem={selectedSortItem}
              loading={loading}
              projects={projects}
              currentPage={currentPage}
              sortItems={sortItems}
              favouriteProjects={favouriteProjects}
              handleSelectedSortItem={handleSelectedSortItem}
              handlePageChanged={handlePageChanged}
              handleArchive={handleArchive}
              handleFavourite={handleFavourite}
              map={createMap()}
            />
          </div>

          <div className="d-none d-md-flex row mb-5">
            <LargeScreen
              loading={loading}
              count={count}
              sortItems={sortItems}
              projects={projects}
              currentPage={currentPage}
              selectedSortItem={selectedSortItem}
              favouriteProjects={favouriteProjects}
              handleSelectedSortItem={handleSelectedSortItem}
              handlePageChanged={handlePageChanged}
              handleArchive={handleArchive}
              handleFavourite={handleFavourite}
              latLng={latLng}
              map={createMap()}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectBoardList;
